export default __webpack_public_path__ + "6d85014bea820f9efa7c4308847cee2d.svg";